var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser3Bw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 6C0 2.68629 2.68629 0 6 0H36C39.3137 0 42 2.68629 42 6V36C42 39.3137 39.3137 42 36 42H6C2.68629 42 0 39.3137 0 36V6Z",
    fill: "#EEEDF0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5833 20.9997L21 26.4163L31.8333 15.583",
    stroke: "#2F2B3D",
    strokeOpacity: 0.9,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.697 20.4693C10.4041 20.1765 9.92922 20.1765 9.63633 20.4693C9.34343 20.7622 9.34343 21.2371 9.63633 21.53L10.697 20.4693ZM15.053 26.9467C15.3459 27.2396 15.8208 27.2396 16.1137 26.9467C16.4065 26.6538 16.4065 26.1789 16.1137 25.886L15.053 26.9467ZM20.4697 20.4693C20.1768 20.7622 20.1768 21.2371 20.4697 21.53C20.7626 21.8229 21.2374 21.8229 21.5303 21.53L20.4697 20.4693ZM26.947 16.1133C27.2399 15.8204 27.2399 15.3456 26.947 15.0527C26.6541 14.7598 26.1792 14.7598 25.8863 15.0527L26.947 16.1133ZM9.63633 21.53L15.053 26.9467L16.1137 25.886L10.697 20.4693L9.63633 21.53ZM21.5303 21.53L26.947 16.1133L25.8863 15.0527L20.4697 20.4693L21.5303 21.53Z",
    fill: "#2F2B3D",
    fillOpacity: 0.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser3Bw);
export default __webpack_public_path__ + "static/media/user-3-bw.7c611f3ad61ea492ef81fdad847ff2a4.svg";
export { ForwardRef as ReactComponent };